import React from 'react';

const Favourite = ({ className }) => {
    return (
        <svg width="43" height="43" viewBox="0 0 43 43" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="21.5" cy="21.5" r="21.5" fill="white" />
            <g clipPath="url(#clip0_379_53147)">
                <path d="M25.0628 15.75C24.3166 15.7482 23.5854 15.9588 22.9545 16.3573C22.3236 16.7557 21.8192 17.3255 21.5003 18C21.124 17.1823 20.4786 16.5186 19.6717 16.1197C18.8648 15.7208 17.9455 15.6109 17.0673 15.8085C16.1892 16.0061 15.4055 16.4991 14.8472 17.2052C14.289 17.9112 13.99 18.7875 14.0003 19.6875C14.0003 23.8125 21.5003 29.25 21.5003 29.25C21.5003 29.25 29.0003 23.8125 29.0003 19.6875C29.0003 18.6433 28.5854 17.6417 27.847 16.9033C27.1086 16.1649 26.107 15.75 25.0628 15.75Z" fill="#B6B6B6" />
            </g>
            <defs>
                <clipPath id="clip0_379_53147">
                    <rect width="15" height="15" fill="white" transform="translate(14 15)" />
                </clipPath>
            </defs>
        </svg>
    )
}

export default Favourite;